import type { Viewer } from '../../viewer/Viewer';
import type { MeasureClosestPointResult } from '../types/measure-distance-types';
import type { MeasureEntityRef } from '../types/measure-types';
import { MeasureClosestPointResolver } from './MeasureClosestPointResolver';

/**
 * 两几何体全局最近点参考点策略。
 *
 * 职责：包装 {@link MeasureClosestPointResolver}，作为进入测量时的默认双选策略。
 */
export class MeasureClosestPointReferenceStrategy {
    /** 最近点求解器。 */
    private readonly closestPointResolver: MeasureClosestPointResolver;

    /**
     * @param viewer Viewer 实例。
     */
    public constructor(viewer: Viewer) {
        this.closestPointResolver = new MeasureClosestPointResolver(viewer);
    }

    /**
     * 求解两实体之间的全局最近点。
     *
     * @param firstEntity 先选实体。
     * @param secondEntity 后选实体。
     * @returns 最近点结果；无法求解时返回 null。
     */
    public resolve(
        firstEntity: MeasureEntityRef,
        secondEntity: MeasureEntityRef,
    ): MeasureClosestPointResult | null {
        return this.closestPointResolver.resolve(firstEntity, secondEntity);
    }
}
